import { ModelBase } from '../shared/model.base';

export class Contact extends ModelBase {
  companyId: number;
  name: '';
  role: '';
  email: '';
  phoneNumber: '';

  constructor() {
    super();
  }
}
